import(/* webpackMode: "eager" */ "/hisea-ssr/src/app/(app)/student-discounts/loading.js");
